import React from 'react';
import Header from '../../_components/header/header';
import Footer from '../../_components/footer/footer';
import { Container } from 'reactstrap';
class About extends React.Component {
    render() {
        return (
            <>
                <Header />
                <div className="banner-img">
                    <img src="/images/about.png" alt="" className="img-fluid" />
                </div>
                <Container fluid={true}>
                    <h2 className="home-heading text-center mt-5">About Us</h2>
                    <p className="text-center">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr</p>
                </Container>
                <Footer />
            </>
        )
    }
}
export default About